import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApplicationsResponse} from "../model/responses/applications-response";
import {ApplicationFilters} from "../model/filters/application-filters";
import {HttpUtils} from "../shared/http.utils";

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  private readonly applicationsUrl: string;

  constructor(private http: HttpClient) {
    this.applicationsUrl = 'catalog/applications';
  }

  public getApplications(offset?: number, limit?: number, filters?: ApplicationFilters): Observable<ApplicationsResponse> {
    let url = `${this.applicationsUrl}?code=${filters.code || ''}&sortOrder=${filters.getOrder()}&sortField=${filters.sortField}`
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    return this.http.get<ApplicationsResponse>(url, options);
  }

  public getApplication(applicationUuid: string) {
    let url = `${this.applicationsUrl}/${applicationUuid}`
    return this.http.get<any>(url)
      .toPromise()
      .then((response: any) => response)
      .catch();
  }

  public createApplication(applicationData: FormData): Promise<void> {
    return this.http.post(this.applicationsUrl, applicationData)
      .toPromise()
      .then(()=>{})
      .catch();
  }

  public editApplication(applicationData: FormData, uuid: string) {
    let url = `${this.applicationsUrl}/${uuid}`
    return this.http.put(url, applicationData).toPromise().catch();
  }
  public deleteApplication(uuid: string) {
    let url = `${this.applicationsUrl}/${uuid}`
    return this.http.delete(url);
  }
}
